/*

  Developed by: DXC Technology Singapore PTE LTD
  Initial development date: 03 Jun 2020

  This module is used to handle the following 
  1. JAVA to PEGA rest service
  2. Error handling 
  3. User OS and browser information

  Please ensure to include comments each modified section
  Include Name, date and ITSR or any change request code

*/ 
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router'
import * as $ from 'jquery';
import 'rxjs';
import { AppComponent } from 'src/app/app.component';

@Injectable({
  providedIn: 'root'
})
export class ConnectRestService {

  constructor(
    private httpClient: HttpClient,
    private router : Router,
    private AppComponent : AppComponent
  ) { }

  /*
    [Sonny - 03 Jun 2020]
    [Initial Development]
    To be used for testing purposes only.
    Should be commented when deployed in production
  */
  consoleLog(datastring, datavalue){
    if(sessionStorage.enableLog){
      // console.log(datastring + ': ' + JSON.stringify(datavalue))
    }
  }

  showLoader(){
    //show loading screen
    $('.loader').removeClass("hidden");
  }

  hideLoader(){
    //hide page loader
    $('.loader').addClass("hidden");
  }
  /*
    [Sonny - 03 Jun 2020]
    [Initial Development]
    Handle component rest service
  */
  async connectRest(data, RequestID, httpClientOption){

    this.showLoader();

    //used to prevent back button --- added by Sonny
    sessionStorage.currentPage = window.location.href;

    //Retrieve corresponding request URL
    var requestURL = this.getJavaURL(RequestID);

    //Retrieve ServiceBoday struture and values
    var ServiceHeader = this.getServiceHeader(data,RequestID);

    if(RequestID=="S0010"){
      sessionStorage.RequestData = JSON.stringify(data)
    }

    if(RequestID=="S0020" && data.ApplicantList[1].Name==""){
      // delete data.ApplicantList[1]
      data.ApplicantList = data.ApplicantList.splice(0,1);
    }

    //To remove ServiceBody from component request in case it is included in the request
    if(data.ServiceBody){
      data = data.ServiceBody
    }

    //compose a proper request structure
    var RequestData = {
      ServiceBody : data,
      ServiceHeader : ServiceHeader
    }

    return await this.connect(RequestData, requestURL, httpClientOption).then(
      success =>{
          //To validate the request before sending to each component requestor
          var validatedResponseData = this.validateResponse(success, RequestID)
          return validatedResponseData
      },
      failed=>{
        //To validate the request before sending to each component requestor
        var validatedResponseData = this.validateResponse(failed, RequestID)
        return validatedResponseData
      }
    )

  }

  /*
    [Sonny - 03 Jun 2020]
    [Initial Development]
    Post request connect service
  */ 
  private connect(data, requestURL, requestOption){
    
    this.consoleLog('connect.start','')
    this.consoleLog('request',data)

    const httpClientOption={
      "headers":requestOption
    }
      
    return new Promise((success, failed)=> this.httpClient
    .post(requestURL, data, httpClientOption)
    .subscribe(
      data => {success(data)},
      error => {failed(error)}
    ))
  }

  /*
    [Sonny - 03 Jun 2020]
    [Initial Development]
    To validate each request before sending to requestor
    Any specific scenario should be handle in this function
  */
  private validateResponse(data, RequestID){

    this.consoleLog('response' , data)
    var dataResponse = {Status:null}
    if((data.ServiceHeader && data.ServiceHeader.Status == "Success") || (data.status && data.status == "SUCCESS")){
    
      if(data.ServiceBody){
        data.ServiceBody.Status = "Success"
        dataResponse = data.ServiceBody
      } else if(data.status == "SUCCESS") {
        data.Status = "Success";
        dataResponse = data;
      } else{
        dataResponse = {Status:"Success"}
      }
      if(data.ServiceHeader && data.ServiceHeader.RequestID != "R0300" && data.ServiceHeader.RequestID != "R0700"){
        this.updateServiceHeader(data)
      }
      
    }else{
      var Message={ErrorCode: null, ErrorDescription: null}
      if(data.ServiceMessage){
        Message = data.ServiceMessage
      }else{
        Message.ErrorCode = data.status
        /* 
          Changed base on AVA item #3
          By: Sonny
          Date: 08 Aug 2020
        */
        //Message.ErrorDescription = data.statusText
        Message.ErrorDescription = "Application encounter some issue, please retry later." 
      }
      if(data.ServiceBody){
        data.ServiceBody.Status = "Failed"
        dataResponse = data.ServiceBody
      }else{
        dataResponse = {Status:"Failed"}
      }

      //Modify this condition if error message is not required to display on the UI
      if((data.ServiceMessage && data.ServiceMessage.ErrorCode != "E0253")||(!data.ServiceMessage)){
        this.displayErrorMessage(Message)
      }
      if(data.ServiceMessage){
        if(data.ServiceMessage.ErrorCode == "EC003" || data.ServiceMessage.ErrorCode == "EC010"){
          this.updateServiceHeader(data)
          sessionStorage.ErrorCode = data.ServiceMessage.ErrorCode
          sessionStorage.ErrorDescription = data.ServiceMessage.ErrorDescription
          this.router.navigate(['/identify-exist',{ErrorCode:data.ServiceMessage.ErrorCode,ErrorDescription:data.ServiceMessage.ErrorDescription}])
        }
        if(data.ServiceMessage.ErrorCode == "EDRP1"){          
          localStorage.setItem("ErrorCode", data.ServiceMessage.ErrorCode);
          if(data.ServiceHeader && data.ServiceHeader.RequestID && data.ServiceHeader.RequestID == 'S0015' && localStorage.getItem('URLParam').includes('U9')) {
            sessionStorage.setItem("IslamicNotEligible", "true");
            dataResponse['errorMessage'] = data.ServiceMessage.ErrorCode;
          } 
          this.router.navigate(['/thank-you']);
        }
        if(data.ServiceMessage.ErrorCode == "EDRP1NL"){
          localStorage.setItem("ErrorCode", data.ServiceMessage.ErrorCode);
          this.router.navigate(['/thank-you']);
        }        
        if(data.ServiceMessage.ErrorCode == "EDRP2"){
          localStorage.setItem("ErrorCode", data.ServiceMessage.ErrorCode);
          this.router.navigate(['/thank-you']);
        }
        if(data.ServiceMessage.ErrorCode == "E007"){
          // localStorage.setItem("ErrorCode", data.ServiceMessage.ErrorCode);
          this.router.navigate(['/company-not-found']);
        }        
        if((data.ServiceMessage.ErrorCode == "E0257" || data.ServiceMessage.ErrorCode == "E0258")
          && data.ServiceMessage.ErrorDescription){
          dataResponse['errorMessage'] = data.ServiceMessage.ErrorDescription;
        }
        if((data.ServiceMessage.ErrorCode == "EC092" ||  data.ServiceMessage.ErrorCode == "EC093" || data.ServiceMessage.ErrorCode == "EC094")
          && data.ServiceMessage.ErrorDescription){
          dataResponse['ServiceMessage'] = data.ServiceMessage;
        }  
      }
    }

    this.hideLoader()
    return dataResponse
  }

  /*
    [Sonny - 03 Jun 2020]
    [Initial Development]
    Retrieve http URL
   */
  private getJavaURL(RequestID){
    var requestURL =null;
  //  // console.log("test get.. ID  " + RequestID.substring(0,1).toUpperCase())
    if(RequestID.substring(0,1).toUpperCase()=="S"){
      requestURL = '/obaoMY/UI/updateMyObaoService'
    }else{
      requestURL = '/obaoMY/UI/retieveMyObaoService'
    }

    switch (RequestID){
      case 'R0300':
        requestURL ='/obaoMY/UI/referenceDataService'
        break;
      case 'R0500':
        requestURL ='/obaoMY/UI/referenceBranchCoodeService'
        break;
      case 'R0700':
        requestURL ='/obaoMY/UI/getPropertyConfigValue'
        break; 
      case 'G0001':
        requestURL ='/obaoMY/UI/getCaptcha'
        break;
      case 'G0002':
        requestURL ='/obaoMY/UI/regenerateCaptcha'
        break; 
      default:
        requestURL = requestURL
        break;
    }

    return requestURL
  }

  /*
    [Sonny - 03 Jun 2020]
    [Initial Development]
    Update required service details for the next call
  */
  private updateServiceHeader(data){
    sessionStorage.ServiceHeader = JSON.stringify(data.ServiceHeader)
  }

  /*
    [Sonny - 03 Jun 2020]
    [Initial Development]
    Compose the ServiceHeader structure to be sent out to PEGA
  */
  private getServiceHeader(RequestData, RequestID){
    var SessionServiceHeader = null
    if(sessionStorage.ServiceHeader){
      SessionServiceHeader = JSON.parse(sessionStorage.ServiceHeader)
    }else{
      SessionServiceHeader = {
        CaseID: null,
        Flow: null,
        TokenID: null,
      }
    }
    
    if(RequestID == "S0020"){
      if(RequestData.OfficerInfo.ReferenceNumber.length > 0){
        SessionServiceHeader.Flow = "0"
      }else{
        SessionServiceHeader.Flow = "1"
      }
    }
    if(RequestID == "S0016"){
      SessionServiceHeader.Flow = "1"
    }
    var PageName = window.location.hash.substr(2);
    PageName = PageName.split("?")[0]
    PageName = PageName.split(";")[0]
    var ServiceHeader = {
      CaseID: SessionServiceHeader.CaseID,
      ChannelID :"MOBAO",
      Flow: SessionServiceHeader.Flow,
      PageName: PageName,
      RegionCode: "MY",
      RequestID: RequestID,
      Status: null,
      TokenID: SessionServiceHeader.TokenID,
      Platform: this.getPlatformInformation()
    }
    return ServiceHeader
  }

  /*
    [Sonny - 03 Jun 2020]
    [Initial Development]
    Handle error messages to be displayed on the screen
  */
  displayErrorMessage(Message){
    //remove existing error message
    $('.ErrorDisplayHTML').remove()
    var errorMessage = null
    var errorCode = null
    if(Message.length == undefined){
      if(Message.ErrorCode){
        errorMessage = Message.ErrorDescription;
        errorCode = Message.ErrorCode;
      }else{
        Message = this.getErrorDescription(Message)
        errorMessage = Message.ErrorDescription;
        errorCode = Message.ErrorCode;
      }
    }else{
      errorMessage = Message[0].ErrorDescription ? Message[0].ErrorDescription : "";
      errorCode = Message[0].ErrorCode;
    }
    
    var errorHTML = '<div class="ErrorDisplayHTML"><div class="ErrorCodeDisplay">'+errorCode+'</div><div class="ErrorMessageDisplay">'+errorMessage+'</div></div>';

    //prepend the erorr message on top of the main-container
    if(errorCode==="E000" || errorCode==="E005" || errorCode==="E009"){
      $('.modal-title-session').html(errorCode);
      $('.modal-body-session').html(errorMessage);
      this.AppComponent.onShowModal();
    }else{
      $('.main-container').prepend(errorHTML)
    }
    

  }

  /* 
    [Sonny - 03 Jun 2020]
    [Initial Development]
    
    Handle all unhandle error scenario from here
    Error code is used for developer to identify the root cause of the issue
  */
  private getErrorDescription(message){
    var Message = {ErrorCode: null, ErrorDescription:"Application encounter some issue, please retry in another 15mins."}
    switch (message.message){
      case "Unexpected token u in JSON at position 0":
        //Issue when converting string to JSON data, mostly when sessionStorage is being converted to JSON structure
        Message.ErrorCode = "E881"
        break;
      default:
        //anything that is uncaught error which not listed on this switch case
        Message.ErrorCode = "E888"
    }
    return Message
  }

  /* 
    [Sonny - 03 Jun 2020]
    [Initial Development]
    
    To get pass browser information to PEGA
    This is used for Data Analytic purposes
  */
  getPlatformInformation(){
    var unknown = '-';


        // browser
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browser = navigator.appName;
        var version = '' + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;

        // Opera
        if ((verOffset = nAgt.indexOf('Opera')) != -1) {
            browser = 'Opera';
            version = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf('Version')) != -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // Opera Next
        if ((verOffset = nAgt.indexOf('OPR')) != -1) {
            browser = 'Opera';
            version = nAgt.substring(verOffset + 4);
        }
        // Edge
        else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
            browser = 'Microsoft Edge';
            version = nAgt.substring(verOffset + 5);
        }
        // MSIE
        else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(verOffset + 5);
        }
        // Chrome
        else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
            browser = 'Chrome';
            version = nAgt.substring(verOffset + 7);
        }
        // Safari
        else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
            browser = 'Safari';
            version = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) != -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // Firefox
        else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
            browser = 'Firefox';
            version = nAgt.substring(verOffset + 8);
        }
        // MSIE 11+
        else if (nAgt.indexOf('Trident/') != -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(nAgt.indexOf('rv:') + 3);
        }
        // Other browsers
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browser = nAgt.substring(nameOffset, verOffset);
            version = nAgt.substring(verOffset + 1);
            if (browser.toLowerCase() == browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        // trim the version string
        if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

        majorVersion = parseInt('' + version, 10);
        if (isNaN(majorVersion)) {
            version = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        // mobile version
        var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // system
        var os = unknown;
        var clientStrings = [
            {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
            {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
            {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
            {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
            {s:'Windows Vista', r:/Windows NT 6.0/},
            {s:'Windows Server 2003', r:/Windows NT 5.2/},
            {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
            {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
            {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
            {s:'Windows 98', r:/(Windows 98|Win98)/},
            {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
            {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
            {s:'Windows CE', r:/Windows CE/},
            {s:'Windows 3.11', r:/Win16/},
            {s:'Android', r:/Android/},
            {s:'Open BSD', r:/OpenBSD/},
            {s:'Sun OS', r:/SunOS/},
            {s:'Chrome OS', r:/CrOS/},
            {s:'Linux', r:/(Linux|X11(?!.*CrOS))/},
            {s:'iOS', r:/(iPhone|iPad|iPod)/},
            {s:'Mac OS X', r:/Mac OS X/},
            {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
            {s:'QNX', r:/QNX/},
            {s:'UNIX', r:/UNIX/},
            {s:'BeOS', r:/BeOS/},
            {s:'OS/2', r:/OS\/2/},
            {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
        ];
        for (var id in clientStrings) {
            var cs = clientStrings[id];
            if (cs.r.test(nAgt)) {
                os = cs.s;
                break;
            }
        }

        var osVersion = unknown;
        
        if (/Windows/.test(os)) {
            osVersion = /Windows (.*)/.exec(os)[1];
            os = 'Windows';
        }

        switch (os) {
            case 'Mac OS X':
                osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
                break;

            case 'Android':
                osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
                break;

            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer)[1];
                break;
        }

      const platform = os + ' ' + osVersion + ' || ' + browser + ' ' + version

      return platform
  }

  clearSessionStorage(){
    sessionStorage.removeItem('TellUsWhoYouAre')
    sessionStorage.removeItem('ServiceHeader')
    sessionStorage.removeItem('captchaSuccess')
  }
}
